import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
// import { getUsersByGroup, addAssignmentByItem } from './ItemService'
import { getUsersByGroupAndRole, addAssignmentByItem } from './ItemService';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';
// import Container from 'components/Container';

const ItemManagerAssignmentAdd = ({
  startDate,
  endDate,
  subscriptionid,
  listItemManagerAssignments,
}): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [managers, setManagers] = useState<any[]>([]);

  //const name = itemName;
  //const [description, setDescription] = useState('');
  const status = 'New';

  const { itemid } = useParams();

  const [selectedUserId, setSelectedUserId] = useState(null);

  const handleChange = (userId) => {
    setSelectedUserId(userId);
  };

  const handleClickOpen = () => {
    listUsersByGroup();
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  useEffect(() => {
    listUsersByGroup();
  }, []);

  function listUsersByGroup() {
    getUsersByGroupAndRole('ROLE_MANAGER')
      .then((response) => {
        setManagers(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  function addItemAssignment(subscriptionid, itemid, selectedUserId) {
    const [id, firstName, lastName] = selectedUserId.split(',');
    const subscriptionId = subscriptionid;
    const userId = id;
    const userRole = 'ROLE_MANAGER';
    const assignment = {
      firstName,
      lastName,
      name,
      status,
      subscriptionId,
      userRole,
      userId,
      startDate,
      endDate,
    };

    addAssignmentByItem(itemid, assignment)
      .then(() => {
        listItemManagerAssignments(itemid);
        handleClose(null, null);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  return (
    <div>
      <Button onClick={handleClickOpen}>Add Manager</Button>
      <Dialog disableEscapeKeyDown open={open}>
        <DialogTitle>Select a Manager</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              {/* <InputLabel htmlFor="demo-dialog-native">Name</InputLabel> */}
              <Select
                native
                value={selectedUserId || ''} // Use selectedUserId as the value
                onChange={(e) => handleChange(e.target.value)}
                input={
                  <OutlinedInput
                    label="Select Manager"
                    id="demo-dialog-native"
                  />
                }
              >
                <option value={''}>Select Manager</option>
                {managers.map((manager) => (
                  <option
                    key={manager.id}
                    value={`${manager.id},${manager.firstName},${manager.lastName}`}
                  >
                    {manager.firstName} {manager.lastName}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(null, null)}>Cancel</Button>
          <Button
            onClick={() =>
              addItemAssignment(subscriptionid, itemid, selectedUserId)
            }
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ItemManagerAssignmentAdd;
